import {
  LOGIN_DATA,
  UPDATE_ONBOARDING_STATE,
  UPDATE_FULL_SCREEN_LOADER,
} from "../actionTypes/authTypes";

export function loginPost(payload) {
  return { type: LOGIN_DATA, payload };
}
export function updateFullScreenLoader(payload) {
  return { type: UPDATE_FULL_SCREEN_LOADER, payload };
}
export function updateOnboardingState(payload) {
  return { type: UPDATE_ONBOARDING_STATE, payload };
}
